import React, { useState } from "react";
import DataTable from "../../../components/AdminTable//DataTable";
import { Link } from "react-router-dom";
import Select from "react-select";

function Inventory() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
      header: "	Ingredient(Code)",
      accessorKey: "IngredientCode",
    },
    {
      header: "Category",
      accessorKey: "Category",
    },
    {
      header: "	Stock Qty/Amount",
      accessorKey: "StockQtyAmount",
    },
    {
      header: "Alert Qty/Amount",
      accessorKey: "AlertQtyAmount",
    },
  ]);
  const [data] = useState([
    {
      SN: 1,
      IngredientCode: "box basbousa Large(006)	",
      Category: "بوكس بسبوسة كبير	",
      StockQtyAmount: "153",
      AlertQtyAmount: "10.00",
    },
  ]);
  const [buttonDataa] = useState([
    {
      buttonText: "Submit",
      path: "submitInventory",
    },
    {
      buttonText: "Ingredient in Alert",
      path: "ingredientsAlert",
    },
  ]);
  const categories = [];

  const options = categories;
  return (
    <main>
      <div className="text-[#7B20C7] text-3xl text-center mb-4 mt-8">Inventory</div>
      <span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>

      <div className="md:flex block flex-wrap gap-5 ms-4 my-2  items-center justify-center">
        <div className="max-w-sm my-2 ">
          <form action="" className="flex items-center">
            <Select
              placeholder={"Category"}
              options={options}
              className="w-2/1"
            />
          </form>
        </div>
        <div className="max-w-sm my-2 ">
          <form action="" className="flex items-center">
            <Select
              placeholder={"Ingridient"}
              options={options}
              className="w-2/1"
            />
          </form>
        </div>
        <div className="max-w-sm my-2 ">
          <form action="" className="flex items-center">
            <Select
              placeholder={"Food Menu"}
              options={options}
              className="w-2/1"
            />
          </form>
        </div>

        {buttonDataa &&
          buttonDataa.map((data, index) => (
            <Link
              className="bg-[#7B20C7] text-white text-sm px-3 text-center py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150  w-fit"
              type="button"
              to={data.path}
              key={index}
            >
              {data.buttonText}
            </Link>
          ))}
        <div className="flex gap-2 my-1">
          <p>Stock Value: S.R 7,650.00</p>
          <svg
            className="fill-[#7B20C7]	my-1 "
            xmlns="http://www.w3.org/2000/svg"
            height="16"
            width="10"
            viewBox="0 0 320 512"
          >
            <path d="M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z" />
          </svg>
        </div>
      </div>
      {/* 
      {buttonForm &&
          buttonForm.map((data, index) => (
            <Link
              className=" bg-[#7B20C7] text-white text-sm px-3 text-center py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150  w-fit"
              type="button" key={index}>
              {data.buttonText}
            </Link>
          ))} */}
      <DataTable columns={columns} data={data} />
    </main>
  );
}

export default Inventory;
